/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const paginatedAPIImportListResultsItemUserOneUsernameMax = 150;

export const paginatedAPIImportListResultsItemUserOneUsernameRegExp =
    new RegExp('[\\w.@+-]+');
export const paginatedAPIImportListResultsItemUserOneFirstNameMax = 150;

export const paginatedAPIImportListResultsItemUserOneLastNameMax = 150;

export const paginatedAPIImportListResultsItemAppVersionMax = 25;

export const PaginatedAPIImportList = zod.strictObject({
    count: zod.number().optional(),
    has_next: zod.boolean().optional(),
    has_previous: zod.boolean().optional(),
    limit: zod.number().optional(),
    page: zod.number().optional().describe('The current page number'),
    pages: zod.number().optional().describe('The total number of pages'),
    results: zod
        .array(
            zod.strictObject({
                created_at: zod.number(),
                user: zod
                    .strictObject({
                        id: zod.number(),
                        username: zod
                            .string()
                            .max(
                                paginatedAPIImportListResultsItemUserOneUsernameMax,
                            )
                            .regex(
                                paginatedAPIImportListResultsItemUserOneUsernameRegExp,
                            )
                            .describe(
                                'Required. 150 characters or fewer. Letters, digits and @\/.\/+\/-\/_ only.',
                            ),
                        first_name: zod
                            .string()
                            .max(
                                paginatedAPIImportListResultsItemUserOneFirstNameMax,
                            )
                            .optional(),
                        last_name: zod
                            .string()
                            .max(
                                paginatedAPIImportListResultsItemUserOneLastNameMax,
                            )
                            .optional(),
                    })
                    .nullable(),
                import_type: zod
                    .union([
                        zod
                            .enum(['orgUnit', 'instance', 'bulk', 'storageLog'])
                            .describe(
                                '\* `orgUnit` - Org Unit\n\* `instance` - Form instance\n\* `bulk` - Bulk Org Units and Instances\n\* `storageLog` - Storage logs',
                            ),
                        zod.enum(['']),
                        zod.literal(null),
                    ])
                    .nullish(),
                json_body: zod.unknown(),
                headers: zod.unknown(),
                has_problem: zod.boolean().optional(),
                file: zod.url().nullish(),
                app_id: zod.string().optional(),
                app_version: zod
                    .string()
                    .max(paginatedAPIImportListResultsItemAppVersionMax)
                    .optional(),
                exception: zod.string().optional(),
            }),
        )
        .optional(),
});

export type PaginatedAPIImportList = zod.input<typeof PaginatedAPIImportList>;
export type PaginatedAPIImportListOutput = zod.output<
    typeof PaginatedAPIImportList
>;
